<div *ngIf="sort">
    <fa-icon *ngIf="sort.active !== columnName" icon="sort"></fa-icon>
    <fa-icon *ngIf="sort.active === columnName" [icon]="sort.direction === 'asc' ? 'sort-up' : 'sort-down'"></fa-icon>
</div>
